export enum TypeOfDateSettingsEnumAlarms {
  'FIXED_DATE' = 'FIXED_DATE',
  'REALTIME' = 'REALTIME',
  "LAST_EVENTS" = 'LAST_EVENTS',
}
